export enum PaymentProviderType {
    Undefined = 0,
    Stripe = 1,
    Halito = 2
}
